import { Fragment, useRef, useState } from 'react';
import { Menu, MenuIcon, MenuItem, MenuLabel, MenuSub, MenuTitle, MenuToggle } from '@/components/menu';
import { KeenIcon } from '@/components/keenicons';
import { useLanguage } from '@/i18n';
import { ModalShareProfile } from '@/partials/modals/share-profile';
import { ModalGiveAward } from '@/partials/modals/give-award';
import { ModalReportUser } from '@/partials/modals/report-user';
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';

const ContactDetailsMenu = ({onEdit, onDelete}) => {
  const { ability } = useAbility();
  const canEditContact = ability.can('handle', 'contact')
  const canDeleteContact = ability.can('delete', 'contact');
  const itemRef = useRef(null);
  const {
    isRTL
  } = useLanguage();
  const [ShareProfileModalOpen, setShareProfileModalOpen] = useState(false);
  const handleSettingsModalOpen = () => {
    setShareProfileModalOpen(true);
    itemRef.current?.hide();
  };
  const handleShareProfileModalClose = () => {
    setShareProfileModalOpen(false);
  };
  const [giveAwardModalOpen, setGiveAwardModalOpen] = useState(false);
  const handleGiveAwardModalOpen = () => {
    setGiveAwardModalOpen(true);
    itemRef.current?.hide();
  };
  const handleGiveAwardModalClose = () => {
    setGiveAwardModalOpen(false);
  };
  const [reportUserModalOpen, setReportUserModalOpen] = useState(false);
  const handleReportUserModalOpen = () => {
    setReportUserModalOpen(true);
    itemRef.current?.hide();
  };
  const handleReportUserModalClose = () => {
    setReportUserModalOpen(false);
  };
  return <Fragment>
      <Menu className="items-stretch">
        <MenuItem ref={itemRef} toggle="dropdown" trigger="click" dropdownProps={{
        placement: isRTL() ? 'bottom-start' : 'bottom-end',
        modifiers: [{
          name: 'offset',
          options: {
            offset: isRTL() ? [0, -10] : [0, 10] // [skid, distance]
          }
        }]
      }}>
          {(canEditContact ||canDeleteContact ) && (
            <MenuToggle className="btn btn-sm btn-icon btn-light">
              <KeenIcon icon="dots-vertical" />
            </MenuToggle>
          )}
          <MenuSub className="menu-default" rootClassName="w-full max-w-[220px]">
            <Can I="handle" a="contact" ability={ability}>
              <div className='menu-item' onClick={onEdit}>
                <div className='menu-label'>
                  <span className='menu-icon'>
                    <KeenIcon icon="pencil" />
                  </span>
                  <span className='menu-title'>Edit</span>
                </div>
              </div>
            </Can>
            <Can I="delete" a="contact" ability={ability}>
              <div className='menu-item' onClick={onDelete}>
                <div className='menu-label'>
                  <span className='menu-icon'>
                    <KeenIcon icon="trash" />
                  </span>
                  <span className='menu-title'>Delete</span>
                </div>
              </div>
            </Can>
          </MenuSub>
        </MenuItem>
      </Menu>

      <ModalShareProfile open={ShareProfileModalOpen} onOpenChange={handleShareProfileModalClose} />
      <ModalGiveAward open={giveAwardModalOpen} onOpenChange={handleGiveAwardModalClose} />
      <ModalReportUser open={reportUserModalOpen} onOpenChange={handleReportUserModalClose} />
    </Fragment>;
};
export { ContactDetailsMenu };